import { OpsAPI } from '@api/buser-http-client';

const verifyMonthlyTollStatement = async (companyId) => {
  await OpsAPI.verifyMonthlyTollStatement(companyId)
    .then((data) => Promise.resolve(data))
    .catch((error) => Promise.reject(error.response?.data || error.response));
};

export { verifyMonthlyTollStatement };
